/**
 * ConfirmDeleteImageModal — confirms hard-deleting a photo + all its
 * derived files. Tank Redesign port (PR 9.1 cont.): mechanical extraction
 * from the inline modal in pages/Edit.jsx.
 */

import Modal from '../../../../shared/components/ui/Modal';
import Button from '../../../../shared/components/ui/Button';

export default function ConfirmDeleteImageModal({
  isOpen,
  imageId,
  onCancel,
  onConfirm,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} size="sm">
      <Modal.Header onClose={onCancel}>Confirm Delete</Modal.Header>
      <Modal.Body>
        <p>Delete image {imageId} and all related data/files?</p>
        <p style={{ marginTop: 8, fontSize: 13, color: '#999' }}>
          This action cannot be undone.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="ghost" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
